export default {
    loaded: "tasks.loaded",
    update: {
        one: "tasks.update.one"
    }
}